export default __webpack_public_path__ + "static/media/mockup.9073aaf4.jpg";